module.exports = __webpack_public_path__ + "static/img/code.28b2d4a0.png";